import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Badge, Button, Card, EmptyState, PageHeader, SkeletonRows } from "../components/ui";
import { templateService, type ProjectTemplate } from "../services/template.service";

export default function TemplatesPage() {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState<ProjectTemplate[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    templateService
      .list()
      .then(setTemplates)
      .catch((err: Error) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <PageHeader
        title="Templates"
        description="Arquiteturas oficiais utilizadas pelos projetos gerados."
      />

      {error && (
        <p className="rounded-md border border-danger/40 bg-danger/10 p-3 text-sm text-danger">{error}</p>
      )}

      {loading ? (
        <SkeletonRows rows={3} />
      ) : templates.length === 0 ? (
        <EmptyState
          title="Nenhum template cadastrado"
          description="Rode o seeder de templates para carregar o template oficial."
        />
      ) : (
        <div className="grid gap-4 md:grid-cols-2">
          {templates.map((template) => (
            <Card
              key={template.id}
              title={template.name}
              subtitle={template.stack ?? undefined}
              action={template.is_default ? <Badge tone="ok">padrão</Badge> : null}
            >
              <p className="text-sm text-ink-muted">{template.description ?? "Sem descrição."}</p>
              {template.version && (
                <p className="mt-2 text-xs text-ink-muted">
                  Versão {template.version} · atualizações do template não alteram projetos já criados.
                </p>
              )}
              {(template.module_options?.length ?? 0) > 0 && (
                <ul className="mt-3 space-y-1 text-sm text-ink-muted">
                  {template.module_options?.map((option) => (
                    <li key={option.key}>
                      <span className="text-slate-200">{option.name}</span>
                      {option.default ? " · incluído por padrão" : " · opcional"}
                    </li>
                  ))}
                </ul>
              )}
              <Button
                className="mt-4"
                size="sm"
                variant="secondary"
                onClick={() => navigate("/projects/new")}
              >
                Criar projeto com este template
              </Button>
            </Card>
          ))}
        </div>
      )}
    </>
  );
}
